<template>
  <div class="h-min-content mx-auto mb-4 w-2/4">
    <div class="p-8 bg-white rounded-2xl shadow-lg mx-4">
      <h2 class="text-center text-2xl text-blue-dark py-2"><b>Su inconformidad contra un emisor de valores fue registrada correctamente</b></h2>
      <BaseButton type="button" @click.native="backToStart()" class="mx-auto w-1/2 mt-6" label="VOLVER" />
    </div>
  </div>
</template>

<script>

export default {
  methods: {
    backToStart() {
      this.$router.push('/customer');
    }
  }
}
</script>
